/* Zoom sulla posizione di partenza e visualizzazione del layer delle biglietterie */

import { useLeaflet } from "react-leaflet";

// Import risorse per la Location
import "leaflet.locatecontrol";
import { connect } from "react-redux";

 const ZoomTicket = (props) => {
    const { map } = useLeaflet();
    try {
        
        map.fitBounds([props.positionTicket.positionTicket,props.positionTicket.positionTicket], {maxZoom: 15}); 
        
        
    } catch (error) {
        
    }
    
   
    return null;
};

const mapStateToProps = state => {
    return {
        positionTicket: state.positionTicket
    }
  }
export default connect(mapStateToProps) (ZoomTicket)